import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {SIZE_PAGINATION} from "../../conf";
import {isValidIdentifier} from "../../utils/textOptions";

export const findWorkInformation = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/income/current`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/current', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /income/current`);
    })
}

export const useFindWorkInformation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findWorkInformation(data),
    });
}

export const findHistoricalWorkInformation = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/income/historical`,
        {
            identifier: data.identifier,
            page: data?.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/historical', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /income/historical`);
    })
}

export const useFindHistoricalWorkInformation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findHistoricalWorkInformation(data),
    });
}

/**
 * Consulta el detalle mensual del historial laboral paginado.
 *
 * @param data identificador y paginación
 * @returns página con detalles de ingresos mensuales descifrados
 */
export const findEmploymentHistoryDetails = async (data: SearchParamsInterface) => {
    if (!isValidIdentifier(data.identifier)) return null;
    return await configAxios.post(
        `/income/historical/details`,
        {
            identifier: data.identifier,
            page: data?.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/historical/details', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /income/historical/details`);
    })
}

export const useFindEmploymentHistoryDetails = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findEmploymentHistoryDetails(data),
    });
}

export const findGraphicMachining = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/chart/monthly_income`,
        {
            identifier: data.identifier,
            filterByAxisX: data.months ? data.months : 12,
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/graphicMachining', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /chart/monthly_income`);
    })
}

export const useFindGraphicMachining = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findGraphicMachining(data),
    });
}

